// ExamplesTab — färdiga prompts att klippa in i AI-chatten. Extraherad
// ur AiJsonDialog (#4 slice 2). EXAMPLE_PROMPTS bor i `examplePrompts.ts`
// för react-refresh-kompatibilitet.

import { CopyButton } from './CopyButton';
import { EXAMPLE_PROMPTS } from './examplePrompts';

export function ExamplesTab() {
  return (
    <div className="mt-0 space-y-4 pr-4">
      <h3 className="text-lg font-semibold">Ready-to-Use Prompts</h3>
      <p className="text-muted-foreground">
        Copy any of these prompts and paste them after the system prompt in your AI chat. Adapt the details to match your specific needs.
      </p>

      {EXAMPLE_PROMPTS.map((example, i) => (
        <div key={i} className="rounded-lg border border-border overflow-hidden">
          <div className="flex items-center justify-between px-4 py-2.5 bg-muted">
            <h4 className="font-medium text-sm">{example.title}</h4>
            <CopyButton text={example.prompt} label={`Copy ${i}`} />
          </div>
          <pre data-copy-target={`Copy ${i}`} className="p-4 font-mono text-xs whitespace-pre-wrap break-words text-muted-foreground">
            {example.prompt}
          </pre>
        </div>
      ))}

      <div className="p-3 rounded-lg bg-accent/10 border border-accent/20 text-sm">
        <strong>Pro tip:</strong> Combine the system prompt + an example prompt + your own modifications for the best results.
        You can also say "make it more detailed" or "add a sub-layer inside [group name]" to iteratively refine.
      </div>
    </div>
  );
}
